// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1Nz63","obliqueLineWrap":"membershipbadge_obliqueLineWrap__13b6y","obliqueLine":"membershipbadge_obliqueLine__2IOIc"};